
import {Vue} from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { RouteLocationNormalized } from 'vue-router';

//Vue本体がComposition API方向を向いているので、どこまでクラスをサポートし続けられるか不明なため、
//継承はちょっと深入りし過ぎな気がするけど、他に統一する方法がみつからないので共通クラスを作る
//（vue-class-componentもVue公式のパッケージだけど、なんか内部での方向性の違いが生じているように感じる…）
//（Composition API、遠い変数との関係を記述しやすくするために、近くの変数の定義を面倒にするのはあまり良い考えではないと思うので、採用は見送りしています。。）
export default class extends Vue{

    //url変更時の共通のイベントを定義。
    //共通化の理由について。
    //普通に$routeをwatchすると、別画面に出ていく場合のURL変更イベントも拾ってしまう。
    // 1. URL変更される -> 2. Watch("$route") イベントの実行 -> 3.unmountイベントの実行（別画面に行きコンポーネントは非表示になる）
    //の順に実行される。
    //このため、2.のタイミングで、別画面に移動するのに、不要な処理が実行される。

    //なのでunmountの後にonUrlChangeを実行する。
    //（本当は現在のライフサイクルを取得する方法でもあればよかったのだけど。$route.params.userNameのようにそのURL時にしかないプロパティをWatchするという手もあるが汎用的ではない）
    //ちなみにcreatedのタイミングでも実行される。

    //継承コンポーネントがbeforeUnmount、もしくは、unmountedの片方を上書きできるように、両方でフラグをOFFにする。
    private_isAlive = true
    beforeUnmount(){
        this.private_isAlive = false
    }
    unmounted(){
        this.private_isAlive = false
    }

    @Watch("$route", { immediate: false, deep: false })
    private_onUrlChange(newVal: RouteLocationNormalized, oldVal: RouteLocationNormalized) {
        this.$nextTick(()=>{
            // @ts-expect-error
            //immediate: falseなので、createdのタイミングでは実行されないので注意！
            if(this.private_isAlive) this.onUrlChanged(newVal, oldVal)
        })
    }
}